/**
 * Created by Rinszky on 2017. 01. 23..
 */
var shopeditor = {
    appendCursor:false,
    ctrlDown: false,
    connectionLayers: [],
    locationID:null,
    stages: {},

    /**
     * A kiválasztott elem id-jának a sorszáma, tehát nem "element_165" hanem 165
     */
    _selectedStageID: null,



    appendedObject: {
        templateObjectID: null,
        templateObjectName: null,
        appended: false,
        update: function(templateObjectID){
            this.templateObjectID = templateObjectID;

            if((this.templateObjectID == templateObjectID && this.appended == false) || this.templateObjectID != templateObjectID){
                this.appended = true;
            } else {
                this.appended = false;
            }
        }
    },
    load: function() {
        var params = {};

        $.post('/stages/shopeditor', params, function(resp){
            elements = [];
            shopeditor.stages = resp.stages;
            shopeditor.locationID = resp.locationID;
            shopeditor.connectionLayers = resp.connectionLayers;

            $('.element', '#gridbox').remove();

            shopeditor.loadElements(resp);
            shopeditor.loadConnections(resp.connections);

            actZoom = 1;

            if(typeof resp.xml !== 'undefined' && resp.xml !== null)
            {
                if(typeof resp.xml.guidelines !== 'undefined'){
                    shopeditor.configureGuideLines(resp.xml.guidelines.guideline);
                }

                if(typeof resp.xml.act_zoom !== 'undefined'){
                    actZoom = resp.xml.act_zoom;
                }
            }

            zoomRatio = actZoom == 1 ? 1 : 1.25;

            scale();
        }, 'json');
    },
    loadElements: function(resp){
        $.each( resp.elements, function(index, object)
        {
            var val = {};
            val.element = {};
            val.groups = {};

            var element = shopeditor.configureElements(object, index, true);
            var connectionSvg = SVG('gridsvg');

            connectionSvg.add(element.group);
            $.each(element.images, function (index, image) {
                // shopeditor.bindEvents(image);
                val.element[image.attr('id')] = image;
            });
            shopeditor.bindEvents(element.group);
            val.groups[element.group.attr('id')] = element.group;
            elements.push(val);
        });
    },
    loadStage: function (stageID, left) {
        var params = {};
        params.left = left;
        $.post('/stages/shopeditor/loadStage/'+stageID, params, function(resp){
            shopeditor.load();
        });
    },
    loadConnections: function(resp){
        $.each(resp, function( layerId, connections )
        {
            $.each(connections, function(objectconnectionID, objectConnection) {
                var lineElement = editor.configureConnection(objectConnection);
                var connectionSvg = SVG('gridsvg');

                connectionSvg.add(lineElement);
                editor.bindConnectionEvents(lineElement);
            });
        });
    },
    loadPopup: function(){
        $.post('/stages/shopeditor/loadPopup', {}, function(resp){
            popup(resp, 'Load zone template').dialog();
        });
    },
    loadProject: function(){
        var locationID = $('#templateobjectList tbody tr.active').data('id');
        shopeditor.projectLoad(locationID);
    },
    projectLoad: function(locationID){
        $.post('/stages/shopeditor/projectLoad/' + locationID, {}, function(resp){
            location.reload();
        });
    },
    loadPopupJson: function(page){
        var page = page || $('#page').val();

        $.post('/stages/shopeditor/loadPopup/1', {'like': $('#like').val(), 'page': page}, function(resp){
            $('#templateobjectList tbody').html(resp.templateobjectList);
            $('#panel-footer').html(resp.pager);
            $('#page').val(resp.page);

            shopeditor.loadPopupBindEvent();
        }, 'json');
    },
    loadPopupBindEvent: function(){
        $('#templateobjectList tbody tr').on('click', function(e){
            shopeditor.loadTemplateDescription($(this).data('id'));
        }).on('dblclick', function(e){
            shopeditor.loadTemplateDescription($(this).data('id'));
            shopeditor.loadProject();
        });

        shopeditor.loadTemplateDescription($('#templateobjectList tbody tr').data('id'));
    },
    loadTemplateDescription: function(stageID){
        $('#templateobjectList tbody tr').removeClass('active');
        $('#templateobjectList tbody tr[data-id="' + stageID + '"]').addClass('active');

        $.post('/stages/shopeditor/loadTemplateDescription/' + stageID, {}, function(resp){
            $('#targetDescription').html(resp);
        });
    },
    createPopup: function(){
        $.post('/stages/shopeditor/createPopup', {}, function(resp){
            popup(resp, 'Create new zone template').dialog();
        });
    },
    configureElements: function(elements, stage_name, move)
    {
        var imageElements = {};
        var elementsGroup = SVG.get('element_' + stage_name + '_group') !== null ? SVG.get('element_' + stage_name + '_group') : SVG('gridsvg').group().attr({'id':'element_' + stage_name + '_group'});
        $.each(elements, function (index, element) {
            move = move || false;
            editor.unselected();

            var imageElement = SVG.get('element_' + element.id) !== null ? SVG.get('element_' + element.id) : elementsGroup.image(imagePath + '/' + element.templateobjectid + '/' + element.templateobjectattachment, element.width, element.height);
            if(typeof element.left !== 'undefined'){
                var left = (element.left+(element.centerx - element.width / 2)-shopeditor.stages[stage_name]['stage_size']['leftPosition']);
            }else{
                var left = (element.centerx - element.width / 2);
            }
            if(move){
                imageElement
                    .move(editor.toRelative(left), editor.toRelative(element.centery - element.height / 2))
                    .rotate(element.rotation)
                    .scale(actZoom)
                ;
            }

            imageElement.attr({
                // 'rotate':element.rotation,
                'class':'element',
                'id':'element_' + element.id,
            })
                .data({
                    'objecttype_name':element.objecttypename,
                    'objectfamily_code':element.objectfamilycode,
                    'width':element.width,
                    'height':element.height,
                    'z_index':element.zindex,
                    'id':element.id,
                    'rotation':element.rotation,
                    'objecttypeid':element.objecttypeid,
                    'templateobjectid':element.templateobjectid,
                    'templateobjectattachment':element.templateobjectattachment,
                    'layerid':element.layerid,
                    'resize': element.resize,
                    'centerx': element.centerx,
                    'centery': element.centery,
                });
            imageElements[element.id] = imageElement;
        })

        // editor.selectElement(imageElement);
        return {group:elementsGroup,images:imageElements};
    },
    bindEvents: function(obj)
    {
        obj.off('click');

        obj.draggable(true, {}, function(obj, e){
            var nearestLineH = {},
                nearestLineV = {},
                target = obj.el,
                // nearestXH = 100,
                nearestXV = 100,
                nearestYH = 100;
            // nearestYV = 100;

            // console.log(obj);

            $.each(SVG.select('.verticalGuideLine').members, function(){
                if(Math.abs(target.rbox().x - this.rbox().x) < nearestXV/* && Math.abs(target.rbox().x - this.rbox().x) < nearestYV*/){
                    nearestLineV = this;
                    nearestXV = Math.abs(target.rbox().x - this.rbox().x);
                }else if(Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestXV/* && Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestYV*/){
                    nearestLineV = this;
                    nearestXV = Math.abs(target.rbox().x + target.rbox().w - this.rbox().x);
                }
                // if(Math.abs(target.rbox().y - this.rbox().y) < nearestYV && Math.abs(target.rbox().y - this.rbox().y) < nearestXV){
                //     nearestLineV = this;
                //     nearestYV = Math.abs(target.rbox().y - this.rbox().y);
                // }else if(Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestYV && Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestXV){
                //     nearestLineV = this;
                //     nearestYV = Math.abs(target.rbox().y + target.rbox().h - this.rbox().y);
                // }
            });
            $.each(SVG.select('.horizontalGuideLine').members, function(){
                // if(Math.abs(target.rbox().x - this.rbox().x) < nearestXH && Math.abs(target.rbox().x - this.rbox().x) < nearestYH){
                //     nearestLineH = this;
                //     nearestXH = Math.abs(target.rbox().x - this.rbox().x);
                // }else if(Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestXH && Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestYH){
                //     nearestLineH = this;
                //     nearestXH = Math.abs(target.rbox().x + target.rbox().w - this.rbox().x);
                // }
                if(Math.abs(target.rbox().y - this.rbox().y) < nearestYH/* && Math.abs(target.rbox().y - this.rbox().y) < nearestXH*/){
                    nearestLineH = this;
                    nearestYH = Math.abs(target.rbox().y - this.rbox().y);
                }else if(Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestYH/* && Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestXH*/){
                    nearestLineH = this;
                    nearestYH = Math.abs(target.rbox().y + target.rbox().h - this.rbox().y);
                }
            });

            var nearestLine = nearestXV < nearestYH?nearestLineV:nearestLineH,
                closest = editor.closestPoint(nearestLine,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                closestH = editor.closestPoint(nearestLineH,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                closestV = editor.closestPoint(nearestLineV,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                offset = {};

            // console.log(nearestLine == nearestLineH, nearestLine == nearestLineV);

            // console.log((Math.abs(target.rbox().x - closest[0]) < 10 || Math.abs(target.rbox().y - closest[1]) < 10) && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg'));

            if((Math.abs(target.rbox().x - closest[0]) < 10 || Math.abs(target.rbox().y - closest[1]) < 10)/* && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg')*/) {
                if (nearestLine.hasClass('verticalGuideLine')) {
                    offset.left = closest[0];
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.top = closestH[1];
                    // }
                } else {
                    offset.top = closest[1];
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.left = closestV[0];
                    // }
                }
            }

            // console.log((Math.abs(target.rbox().x + target.rbox().w - closest[0]) < 10 || Math.abs(target.rbox().y + target.rbox().h - closest[1]) < 10) && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg'));

            if((Math.abs(target.rbox().x + target.rbox().w - closest[0]) < 10 || Math.abs(target.rbox().y + target.rbox().h - closest[1]) < 10)/* && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg')*/) {
                if (nearestLine.hasClass('verticalGuideLine')) {
                    offset.left = closest[0] - target.rbox().w;
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.top = closestH[1] - target.rbox().h;
                    // }
                } else {
                    offset.top = closest[1] - target.rbox().h;
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.left = closestV[0] - target.rbox().w;
                    // }
                }
            }

            // return offset;
            return {top:obj.el._memory._draggable.startPoints.point.x};
        })
            .on('beforedrag', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }


                var element = SVG.get(e.target.id);
                shopeditor.selectElement(element);
                $('.connection-arrow[data-to="' + element.data('id') + '"], .connection-arrow[data-from="' + element.data('id') + '"]').toggle();
            })
            .on('dragstart', function(e){
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                editor.unselected();
            })
            .on('dragmove', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                var element = SVG.get(e.target.id);
                if (parseInt(editor.activeLayerID) !== parseInt(element.data('layerid'))) {
                    e.preventDefault();
                }

                // editor.displayDataV2();
            })
            .on('dragend', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                editor.removeSelectRect();

                var svgGroup = SVG.get(e.target.id);


                svgGroup.data("centerx", editor.fromRelative(svgGroup.rbox().cx + $("#gridbox").parent().scrollLeft()) );
                svgGroup.data("centery", editor.fromRelative(svgGroup.rbox().cy + $("#gridbox").parent().scrollTop()) );

                shopeditor.selectElement(svgGroup);
                editor.saveElement();
            });
        obj.on('click', function (e) {
            var $this = SVG.get(e.target.id);

            if($this.parent().hasClass('ui-targeted')){
                var selected = editor.isSelectedElement();

                $.post('/stages/editor/connectionPopup/0', {objectfromID: selected.data('id'), objecttoID: $(e.target).data('id')}, function(resp){
                    popup(resp, 'Create connection').dialog();
                });
            } else {
                shopeditor.selectElement(SVG.get(e.target.id).parent())
            }
        });


        obj.on('mouseover', function (e) {
            var element = SVG.get(e.target.id);
            var selected = editor.isSelectedElement();

            if (editor.ctrlDown && selected !== false && element.data('id') != selected.data('id')) {
                SVG.select('.element').parent().removeClass('ui-targeted');
                SVG.select('.element').off('mouseout');

                element.parent().addClass('ui-targeted');
                editor.addSelectRect(element);
                element.on('mouseout', function(e){
                    element.parent().select('rect').members[0].remove();
                    element.off('mouseout').parent().removeClass('ui-targeted');
                });
            }
        });
    },
    selectElement: function(element)
    {
        $.each(SVG.select('g:not(#'+element.attr('id')+'_group) .selected').members, function () {
            SVG.get(this.node.id).remove();
        });

        editor.unselected();
        // editor.displayDataClean();
        shopeditor._selectedStageID = element.data('id');


        element.addClass('ui-selected');

        shopeditor.addSelectRect(element);

        // editor.displayDataV2();

        // var elementListPanel = $('#layer_' + $(element).data('layerid') + ' .elementListPanel');
        //
        // elementListPanel.animate({
        //     scrollTop: (elementListPanel.scrollTop() + $('#element_list_' + element.data('id')).position().top
        //     - elementListPanel.height() / 2 + $('#element_list_' + element.data('id')).height() / 2) + 'px'
        // }, 'fast');
    },
    addSelectRect: function (element) {
        console.log(element.bbox(),element.rbox(),element.tbox());
        var rect = element.parent()
            .rect(element.bbox().w+1, element.bbox().h+1)
            .move(element.rbox().x-1, element.rbox().y-1)
            .attr({
                'stroke': '#fff',
                'stroke-width': 1,
                'fill': 'transparent',
                'stroke-dasharray':'5, 5',
            }).addClass('selected').back();
        console.log(rect);
        if(parseInt(element.data('rotation')) > 0){
            rect.attr('transform',element.matrixify().toString());
        }
    },
};